import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Plus, Trash2, ArrowRight } from 'lucide-react';
import { policiesApi } from '../../lib/api';

export default function MyPolicies() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    policiesApi.list().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(refresh, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this policy?')) return;
    await policiesApi.remove(id);
    refresh();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <span className="eyebrow">Policies</span>
          <h1 className="mt-2 text-3xl font-bold text-[#0b1f3a]">My Policies</h1>
        </div>
        <Link to="/home-insurance" className="btn-primary"><Plus size={16} /> New quote</Link>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {loading ? (
          <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
        ) : items.length === 0 ? (
          <EmptyState />
        ) : (
          <ul className="divide-y divide-slate-100">
            {items.map((p) => (
              <li key={p.id} className="p-5 flex flex-col md:flex-row md:items-center gap-4">
                <span className="icon-tile"><FileText size={20} /></span>
                <div className="flex-1">
                  <p className="font-semibold text-[#0b1f3a]">{p.insurer} · {p.type === 'health' ? 'Health' : 'Home'} insurance</p>
                  <p className="text-xs text-slate-500 mt-0.5">Renewal: {p.renewal_date || '—'} · Cover: {p.cover_amount ? `€${p.cover_amount}` : '—'}</p>
                </div>
                <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${
                  p.status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'
                }`}>{p.status}</span>
                <span className="font-semibold text-[#0b1f3a]">€{p.premium}/year</span>
                <button onClick={() => remove(p.id)} className="text-slate-400 hover:text-rose-600 transition-colors" title="Delete"><Trash2 size={16} /></button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="p-10 text-center">
      <FileText size={32} className="mx-auto text-slate-300" />
      <p className="mt-3 text-slate-700 font-semibold">No policies yet</p>
      <p className="text-slate-500 text-sm mt-1">Get a quote and accept it to see it here.</p>
      <Link to="/home-insurance" className="btn-primary mt-5">Start a quote <ArrowRight size={16} /></Link>
    </div>
  );
}
